import { render, staticRenderFns } from "./ComprobacionesRegistros.vue?vue&type=template&id=c200ede6&scoped=true&"
import script from "./ComprobacionesRegistros.vue?vue&type=script&lang=js&"
export * from "./ComprobacionesRegistros.vue?vue&type=script&lang=js&"
import style0 from "./ComprobacionesRegistros.vue?vue&type=style&index=0&id=c200ede6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c200ede6",
  null
  
)

export default component.exports